import styled from "@emotion/native";
import Text from "../Text";

export const Container = styled.TouchableOpacity({
	flexDirection: "row",
	justifyContent: "flex-start",
	alignItems: "center",
	marginBottom: 24,
});

export const Aside = styled.View({
	paddingTop: 3,
});

export const Main = styled.View({
	flex: 1,
});

export const Title = styled(Text)({
	marginBottom: 6,
});

export const Caption = styled(Text)({});

export const ArrowContainer = styled.View({
	width: 40,
	justifyContent: "center",
	alignItems: "center",
});
